/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import * as CognitoService from "@/js/aws/cognito"
import axios from 'axios';

export const GET = "GET"
export const POST = "POST"
export const PUT = "PUT"

export async function get(url, body, headers) {
    return await axios.get(url, {
        headers: headers
    })
}

export async function post (url, body, headers) {
    return await axios.post(url, body, {
        headers: headers
    })
}

export async function put (url, body, headers) {
    return await axios.put(url, body, {
        headers: headers
    })
}

export function getMethodFunc(method) {
    switch (method) {
        case POST: return post
        case GET: return get
        case PUT: return put
        default: return get
    }
}

export async function getJwtToken(session) {
    if (!session) {
        try {
            session = await CognitoService.checkSession() 
        } catch (e) {
            throw e
        }
    }
    return session.getIdToken().getJwtToken()
}

export async function send(url, method, headers, body) {
    try {
        let methodFunc = getMethodFunc(method)
        return await methodFunc(url, body, headers)
    } catch (e) {
        throw e
    }
}